import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ScrollToTop from '../componentes/ScrollToTop/ScrollToTop.js'
import { LandingPage } from '../Pages/LandingPage/index.jsx';
import { Startemy } from '../componentes/PaginaProjetos/ConteudoProjetos/Startemy/index.js';
import { FunnyJoke } from '../componentes/PaginaProjetos/ConteudoProjetos/FunnyJoke/index.js';

const Rotas = () => (
    <BrowserRouter>
    <ScrollToTop />
        <Routes>
            <Route exact path='/' element={<LandingPage />} />
            <Route path='/Project/Startemy' element={<Startemy />}/>
            <Route path='/Project/FunnyJoke' element={<FunnyJoke />}/>
        </Routes>
    </BrowserRouter>
)

export default Rotas